export const GOOGLE_LOGIN_CLIENT_ID =
	'203548288979-604d2hn4jg3ksvcqblmubqp2gv6o4lto.apps.googleusercontent.com';
